import auth from "@/auth"
import store from "@/store"

export default {
  path: '/admin',
  components: {
    default: () => import(/* webpackChunkName: "admin" */ './wrapper.vue'),
    menu: () => import(/* webpackChunkName: "admin" */ './menu.vue'),
  },
  meta: {
    section: 'admin'
  },
  beforeEnter: function (to, from, next) {
    if (! auth.checkAccess('general', ['admin'])) {
      return next(store.state.user.homepage)
    }

    let tasks = [
      store.dispatch('disciplines.get'),
      store.dispatch('events.getAll'),
      store.dispatch('organisations.get'),
    ]

    Promise.all(tasks).then(() => {
      store.dispatch('environment.setTitle', 'Admin')
      next()
    })
  },
  children: [
    {
      path: '/',
      name: 'admin.events',
      component: () => import(/* webpackChunkName: "admin" */ './events.vue'),
    },
    require('./organisations/routes').default,
    require('./users/routes').default,
    require('./invoicing/routes').default,
  ],
}
